import { ApiTenantService } from "./../../../../services/api/api-tenant.service";
import { ApiPlatformService } from "./../../../../services/api/api-platform-service.service";
import { Component, OnInit } from "@angular/core";
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from "@angular/material/core";
import { NotificationsService } from "angular2-notifications";
import { AlertToasterOptions } from "app/class/alert-toaster-options";
import { User } from "app/interfaces/i-user-user";
import { GoogleAnalyticsService } from "app/services/analytics/google-analitics-service";
import { ApiItalyGeoService } from "app/services/api/api-italy-geo.service";
import { ApiUserService } from "app/services/api/api-user.service";
import { AlphabeticOnlyValidator } from "app/services/MaterialValidator/AlphabeticOnlyValidator";
import { EmailCustomValidator } from "app/services/MaterialValidator/EmailCustomValidator";
import { EmptyInputValidator } from "app/services/MaterialValidator/EmptyInputValidator";
import { NumericOnlyValidator } from "app/services/MaterialValidator/NumericOnlyValidator";
import { PasswordValidator } from "app/services/MaterialValidator/PasswordValidator";
import { assign, get } from "lodash";
import { ErrorMessageTranslatorService } from "../../../../ErrorMessageTranslatorService";
import { Region } from "../../../../services/api/api-italy-geo.service";
import { PasswordPolicyValidator } from "../../../../services/MaterialValidator/PasswordPolicyValidator";
import { environment } from "../../../../../environments/environment";
import { Router } from "@angular/router";
import { mergeMap } from "rxjs";

export const MY_FORMATS = {
    parse: {
        dateInput: "DD/MM/YYYY",
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

@Component({
  standalone: false,
    selector: "fuse-dialog-registration",
    templateUrl: "./registration.component.html",
    styleUrls: ["./registration.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class DialogRegistrationComponent implements OnInit {
    public options = AlertToasterOptions;
    public formGroup: UntypedFormGroup;
    public regions: Region[];
    public gender = [
        { id: "male", name: "Maschio" },
        { id: "female", name: "Femmina" },
    ];

    public loading: boolean = true;
    private allMandatoryPrivacy: boolean;

    constructor(
        public dialogRef: MatDialogRef<DialogRegistrationComponent>,
        public toast: NotificationsService,
        private httpItalyGeo: ApiItalyGeoService,
        private apiUserService: ApiUserService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private errorMessageTranslatorService: ErrorMessageTranslatorService,
        private router: Router,
        private platformService: ApiPlatformService,
        private apiTenantService: ApiTenantService
    ) {
        this.httpItalyGeo.getRegions().subscribe((regions) => {
            this.regions = regions;
            this.loading = false;
        });

        this.platformService
            .getOneById(environment.platform_id)
            .pipe(
                mergeMap((platform) =>
                    this.apiTenantService.getDetail(
                        platform.id_tenant.toString()
                    )
                )
            )
            .subscribe((tenant) => {
                this.allMandatoryPrivacy = tenant.all_mandatory_privacy
                    ? true
                    : false;
            });
    }

    ngOnInit(): void {
        this.googleAnalyticsService.pageEmitter("RegistrationPage");

        this.formGroup = new UntypedFormGroup({
            username: new UntypedFormControl(""),
            password: new UntypedFormControl("", [
                Validators.required,
                EmptyInputValidator.whiteSpace,
                PasswordPolicyValidator.policy,
                PasswordValidator.match("confirm_password"),
            ]),
            confirm_password: new UntypedFormControl("", [
                Validators.required,
                PasswordValidator.match("password"),
            ]),
            id_registration_platform: new UntypedFormControl(
                environment.platform_id
            ),
            userdata: new UntypedFormGroup({
                name: new UntypedFormControl("", [
                    Validators.required,
                    AlphabeticOnlyValidator.alphabeticOnly,
                ]),
                surname: new UntypedFormControl("", [
                    Validators.required,
                    AlphabeticOnlyValidator.alphabeticOnly,
                ]),
                email: new UntypedFormControl("", [
                    Validators.required,
                    EmailCustomValidator.email_custom,
                ]),
                gender: new UntypedFormControl("", [Validators.required]),
                phone: new UntypedFormControl("", [
                    Validators.required,
                    NumericOnlyValidator.numericOnly,
                ]),
                id_region: new UntypedFormControl("", [Validators.required]),
                privacyaccept: new UntypedFormControl("", [
                    Validators.required,
                ]),
                privacy_communications: new UntypedFormControl(),
                privacy_third_part: new UntypedFormControl(),
            }),
        });
    }

    navigatePrivacyPolicy() {
        this.dialogRef.close();
        this.router.navigate(["privacy"]);
    }

    onYesClick(): void {
        const updatedModalData: User = assign(this.formGroup.value, {
            noSendMail: false,
            isOperator: false,
        });

        if (this.allMandatoryPrivacy) {
            updatedModalData.userdata.privacy_communications = true;
            updatedModalData.userdata.privacy_third_part = true;
            this.formGroup
                .get("userdata.privacy_communications")
                ?.setValue(true);
            this.formGroup.get("userdata.privacy_third_part")?.setValue(true);
        }

        this.apiUserService.apiCreateUser(updatedModalData).subscribe({
            next: (data) => {
                this.googleAnalyticsService.eventEmitter(
                    "RegistrationPage",
                    "Registration Successfully"
                );
                this.toast.success(
                    "Attenzione",
                    "Ti abbiamo inviato una mail di conferma."
                );
                this.dialogRef.close();
            },
            error: (err) => {
                const errorMessage = get(err, "error.message", "");
                const errorMessageTranslated =
                    this.errorMessageTranslatorService.translate(
                        get(err, "error.message", "")
                    );
                this.googleAnalyticsService.eventEmitter(
                    "RegistrationPage",
                    `Registration Fault (${errorMessage} exist)`
                );
                this.toast.error("Attenzione", errorMessageTranslated);
            },
        });
    }
}
